'use strict'
export default {
    companyList: [{
        id: '01',
        name: '中国工商银行',
        logo: require("../assets/img/icon/1.png"),
		url: 'http://www.icbc.com.cn/icbc/'
    },{
        id: '09',
        name: '中地会',
        logo: require("../assets/img/icon/4.png"),
		url: 'http://www.zhongdihui.com/'
    }, {
        id: '03',
        name: '中国农业银行',
        logo: require("../assets/img/icon/3.png"),
		url: 'https://www.abchina.com/cn/'
    }, {
        id: '02',
        name: '保利地产',
        logo: require("../assets/img/icon/2.png"),
		url: 'http://www.polycn.com/'
    },{
        id: '05',
        name: '中国银行',
        logo: require("../assets/img/icon/5.png"),
		url: 'https://www.boc.cn/'
    }, {
        id: '04',
        name: '美的置业',
        logo: require("../assets/img/icon/8.png"),
		url: 'https://www.mideadc.com/'
    },{
        id: '07',
        name: '中国建设银行',
        logo: require("../assets/img/icon/7.png"),
		url: 'http://www.ccb.com/'
    },{
        id: '15',
        name: '华发股份',
        logo: require("../assets/img/icon/13.png"),
		url: 'https://www.cnhuafas.com/'
    }, {
        id: '25',
        name: 'VANKE',
        logo: require("../assets/img/icon/25.png"),
		url: 'https://www.vanke.com/'
    },{
        id: '13',
        name: '合生创展',
        logo: require("../assets/img/icon/11.png"),
		url: 'http://www.hopson.com.cn/'
    },{
        id: '27',
        name: '中海地产',
        logo: require("../assets/img/icon/27.png"),
		url: 'https://www.coli688.com/'
    },{
        id: '06',
        name: '珠江投资',
        logo: require("../assets/img/icon/10.png"),
		url: 'http://www.gdpr.com/'
    },{
        id: '26',
        name: '金地集团',
        logo: require("../assets/img/icon/26.png"),
		url: 'https://www.gemdale.com/'
    },{
        id: '10',
        name: '敏捷集团',
        logo: require("../assets/img/icon/12.png"),
		url: 'http://www.nimble.cn/'
    },{
        id: '32',
        name: '星河控股集团',
        logo: require("../assets/img/icon/32.png"),
		url: 'http://www.chngalaxy.com/'
    }, {
        id: '12',
        name: '方圆',
        logo: require("../assets/img/icon/14.png"),
		url: 'http://www.fineland.com.cn/'
    },{
        id: '30',
        name: '卓越集团',
        logo: require("../assets/img/icon/30.png"),
		url: 'http://www.excegroup.com/'
    },{
        id: '23',
        name: '能兴',
        logo: require("../assets/img/icon/23.png"),
		url: 'http://www.nenking.cn/'
    },{
        id: '14',
        name: '尚东控股',
        logo: require("../assets/img/icon/16.png"),
		url: 'https://www.top-east.com.cn/'
    },{
        id: '19',
        name: '珠光集团',
        logo: require("../assets/img/icon/19.png"),
		url: 'http://www.zhuguang.com.hk/'
    },{
	    id: '17',
	    name: '星河湾集团',
	    logo: require("../assets/img/icon/17.png"),
		url: 'http://www.star-river.com/'
	},{
        id: '21',
        name: '中惠熙元',
        logo: require("../assets/img/icon/21.png"),
		url: 'http://www.zovie.cn/'
    },{
        id: '31',
        name: '鸿荣源',
        logo: require("../assets/img/icon/35.png"),
		url: 'https://www.chinahoroy.com/'
    },{
        id: '28',
        name: '绿景',
        logo: require("../assets/img/icon/28.png"),
		url: 'http://www.lvgemgroup.com.cn/'
    },
	// {
 //        id: '08',
 //        name: '雅居乐',
 //        logo: require("../assets/img/icon/6.png"),
 //    },{
 //        id: '09',
 //        name: '中地会',
 //        logo: require("../assets/img/icon/4.png")
 //    },{
 //        id: '11',
 //        name: '奥园',
 //        logo: require("../assets/img/icon/9.png")
 //    },      {
 //        id: '16',
 //        name: '龙光',
 //        logo: require("../assets/img/icon/15.png")
 //    }, 
 //    {
 //        id: '18',
 //        name: '光大集团',
 //        logo: require("../assets/img/icon/18.png")
 //    },  {
 //        id: '20',
 //        name: '中泰集团',
 //        logo: require("../assets/img/icon/20.png")
 //    },  {
 //        id: '22',
 //        name: '景业名邦',
 //        logo: require("../assets/img/icon/24.png")
 //    },{
 //        id: '24',
 //        name: '蒙娜丽莎',
 //        logo: require("../assets/img/icon/37.png")
 //    }, {
 //        id: '29',
 //        name: '佳兆业',
 //        logo: require("../assets/img/icon/29.png")
 //    },
	 ]
}